import { Injectable, signal } from '@angular/core';

export enum SnackbarType {
  error = 'error-snack',
  success = 'success-snack',
  info = 'info-snack',
  warning = 'warning-snack',
}

export interface SnackbarDataType {
  message: string;
  variant: SnackbarType;
  open: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  public snackbarData = signal<SnackbarDataType>({
    message: 'پیغام اولیه',
    variant: SnackbarType.info,
    open: false,
  });

  showSnackbar(message: string, type = SnackbarType.success) {
    this.snackbarData.set({
      open: true,
      variant: type,
      message: message,
    });
  }

  hideSnackbar() {
    this.snackbarData.update((prev) => ({ ...prev, open: false }));
  }
}
